<template>
  <div class="main-select-indicator">
    <div class="filter-trigger mt-1">
      <b-form-input ref="inputSearch" @keyup="shortcuts" type="text" id="filter-trigger" class="ml-1 input-pentagro"
        placeholder="Digite Ex: Moagem" v-model="indicatorFilter" />
    </div>
    <b-list-group class="mt-2 list-indicator-group">
      <b-list-group-item 
        :id="item.value" 
        class="indicatorToSelect"
        href="#" 
        v-for="(item,i) in indicators" :key="i" 
        @click="selectIndicator(item)">
        {{ item.text }}
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import Mediator from './utilities/Mediator';

export default {
  name: "Find-Indicator",
  data() {
    return {
      indicatorFilter: "",
      indicators: [],
      indicatorsBkp: [],
      shortCutSelected: null,
      keyToIndex: new Map()
    }
  },

  watch: {
    indicatorFilter(value) {
      this.findValue(value)
    }
  },

  methods: {
    init(indicators) {
      this.indicators = indicators
      this.indicatorsBkp = indicators
      this.$refs.inputSearch.focus()
    },

    selectIndicator(ref) {
      var item = JSON.parse(JSON.stringify(ref))
      Mediator.notify(item, "set-indicator")
      this.$bvModal.hide("find-indicator")
    },

    findValue(value) {
      this.unSelectThis(this.shortCutSelected)
      if (value) {
        const partys = value.split("*");
        this.indicators = this.indicatorsBkp.filter(i => {
          let returnValue = false;
          for (var element of partys) {
            returnValue = JSON.stringify(i).toUpperCase().includes(element.toUpperCase())
            if (!returnValue) break;
          }
          return returnValue
        })
      }
      else
        this.indicators = this.indicatorsBkp

      this.keyToIndex = new Map();
      this.indicators.forEach((i, ix) => {
      if(!this.keyToIndex.has(i.value))
        this.keyToIndex.set(i.value, ix)
    })
    },

    unSelectThis(key){
      let el = document.getElementById(key)
      if(el) el.classList.remove("active")
      this.shortCutSelected = null
    },

    selectThis(){
      let el = document.getElementById(this.shortCutSelected)
      if(el) el.classList.add("active")
    },

    shortcuts(event){
      if(!(event.code == "ArrowDown" || event.code == "ArrowUp" || event.code == "Enter")) return

      if(!this.shortCutSelected) {
        this.shortCutSelected = this.indicators[0].value
        this.selectThis()
        return
      }

      if(event.code == "Enter"){
        let selected = this.indicators.find(i => i.value == this.shortCutSelected)
        this.indicatorFilter = selected.text
        this.selectIndicator(selected)
        return
      }

      let index = this.keyToIndex.get(this.shortCutSelected);
      if(!index && index != 0) return
      this.unSelectThis(this.shortCutSelected)

      if(event.code == "ArrowDown")
        this.shortCutSelected = this.indicators.length == (index + 1) ? this.indicators[this.indicators.length - 1].value : this.indicators[index + 1].value

      if(event.code == "ArrowUp")
        this.shortCutSelected = index == 0 ? this.indicators[0].value : this.indicators[index - 1].value

      this.selectThis()
    }
  },

  mounted() {
    Mediator.notify(this, "initFindIndicator")
    this.indicators = this.indicatorsBkp
    this.keyToIndex = new Map();
    setTimeout(() => {
      this.indicators.forEach((i, ix) => {
        if(!this.keyToIndex.has(i.value))
          this.keyToIndex.set(i.value, ix)
      })
      this.selectThis()
    }, 250);
  },
}
</script>

<style scoped>
#filter-trigger {
  width: 98%;
}

.filter-trigger {
  position: sticky;
  top: 0;
  z-index: 5;
}

.list-indicator-group {
  box-shadow: 0 0 2px #0003;
  height: 45vh;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>